import { BaseDialog } from "@/lib/Components/Dialog/BaseDialog";
import { GenericForm } from "@/lib/Components/Form/Forms/GenericForm";
import { useDialogState } from "@/lib/Components/Dialog/Hooks/useDialogState";
import { DialogSubmitButton } from "@/lib/Components/Dialog/Components/DialogSubmitButton";
import { SelectInput } from "@/lib/Components/Form/Inputs/SelectInput";
import { TextAreaInput } from "@/lib/Components/Form/Inputs/TextAreaInput";
import { useGqlMutation } from "@/lib/GraphQLCodegen/fetcher";
import { ImageGenerationModel } from "@/gql/graphql";
import {
  ImageGenerationFormData,
  imageGenerationValidation,
} from "@/app/Relocations/Forms/imageGenerationValidation";
import { toFormikValidationSchema } from "@/lib/Zod/zod-formik-adapter";
import { regenerateRelocationOgImageMutation } from "@/app/Relocations/GraphQL/generateRelocationOgImageMutation";

export type RelocationImageGenerationDialogProps = {
  relocationId: string;
  onGenerationStarted?: () => void;
};

export function RelocationImageGenerationDialog({
  relocationId,
  onGenerationStarted,
}: RelocationImageGenerationDialogProps) {
  const { close, resolve } = useDialogState();
  const { mutateAsync } = useGqlMutation(regenerateRelocationOgImageMutation);

  const modelOptions = [
    {
      label: "AI Models",
      options: [
        { value: ImageGenerationModel.Openai, label: "OpenAI" },
        { value: ImageGenerationModel.Gemini, label: "Gemini" },
      ],
    },
  ];

  return (
    <BaseDialog title="Generate OG Image">
      <GenericForm<ImageGenerationFormData>
        validationSchema={toFormikValidationSchema(imageGenerationValidation)}
        initialValues={{
          prompt: "",
          model: ImageGenerationModel.Gemini,
        }}
        onSubmit={async (values) => {
          await mutateAsync({
            id: relocationId,
            prompt: values.prompt || undefined,
            model: values.model,
          });

          onGenerationStarted?.();
          resolve?.(true);
          close();
        }}
      >
        <SelectInput name="model" label="AI Model" options={modelOptions} />

        <TextAreaInput
          name="prompt"
          className="col-span-full"
          label="Custom Prompt (optional)"
          textAreaProps={{
            placeholder: "Add custom instructions for the image generation...",
            rows: 4,
          }}
        />

        <DialogSubmitButton text="Generate Image" />
      </GenericForm>
    </BaseDialog>
  );
}
